var _polygon, _polygon2, _polygon3, _tspan, _path, _polygon4, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoApprovalPosts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.11,257.89c-10.73,5.56-19,15.13-24.88,25.67s-9.73,22.1-13.51,33.58l-3.31,59.22c12.49-21.25,22.52-46.22,25.22-70.72l-8.31-.74c5.57-.85,10.25-4.88,13.23-9.67s4.5-10.31,6-15.74L118.41,281A37.59,37.59,0,0,0,134.11,257.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,390.23s-27.11-32.44-26.8-63.41H74.72S62.83,319,63.77,314.62s1.25-21,1.25-21l10,2.5s-7.51-3.75-8.45-9.7S68.78,253,68.78,253s12.2,12.82,16,26,13.61,28.47,10.72,68.51S90.57,390.23,90.57,390.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.31,393.29s29.36-19.56,35.89-44.53l-8.81-2.39s11.28-3.69,11.48-7.42,3.58-17.12,3.58-17.12l-8.6-.18s6.86-1.38,8.91-5.95,5.57-27.39,5.57-27.39S139.71,296,133.82,305.7s-17.17,19.91-23.61,52.73S104.31,393.29,104.31,393.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,281.27a1.38,1.38,0,0,1,.1.34l.24,1c.2.91.49,2.2.86,3.85s.81,3.72,1.29,6.11,1,5.09,1.59,8.11c1.16,6,2.39,13.2,3.65,21.21s2.44,16.82,3.53,26.11,1.89,18.16,2.52,26.23,1.05,15.36,1.29,21.49c.15,3.06.22,5.83.3,8.26s.12,4.52.14,6.24,0,3,0,3.94c0,.43,0,.77,0,1a1.35,1.35,0,0,1,0,.35,3.23,3.23,0,0,1,0-.35c0-.26,0-.6,0-1,0-.93-.08-2.25-.14-3.94s-.11-3.8-.22-6.23-.2-5.2-.38-8.26c-.29-6.11-.77-13.39-1.4-21.46s-1.5-16.93-2.56-26.21S84.63,330,83.44,322,81,306.77,79.9,300.74c-.53-3-1.06-5.73-1.52-8.12s-.85-4.44-1.2-6.12-.58-2.95-.76-3.87l-.19-1A1.76,1.76,0,0,1,76.18,281.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,410.1S62,382,54.3,364.94l5.81-2.48c-4.21.69-8.53-1.12-11.8-3.87s-5.66-6.37-8-9.93l7.66-1.3a28.47,28.47,0,0,1-16.73-13c9,1.48,17.21,6.45,24,12.65a119.54,119.54,0,0,1,14.52,16.82,57.29,57.29,0,0,1,5.63,9.27C79.49,381.76,86.82,399.76,86.81,410.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,304.69a1.77,1.77,0,0,1-.12.29l-.38.82c-.36.74-.86,1.79-1.51,3.12-1.33,2.7-3.21,6.63-5.49,11.51s-4.91,10.72-7.74,17.25-5.79,13.78-8.76,21.44-5.61,15-7.94,21.76-4.29,12.83-5.88,18-2.85,9.32-3.68,12.21c-.42,1.42-.75,2.53-1,3.33-.12.35-.2.64-.27.86a2.19,2.19,0,0,1-.11.29,1.14,1.14,0,0,1,.06-.31q.08-.33.21-.87c.22-.8.52-1.93.9-3.35.77-2.92,2-7.11,3.52-12.27s3.49-11.27,5.77-18,5-14.12,7.91-21.79,6-14.9,8.81-21.44,5.52-12.36,7.85-17.22,4.26-8.76,5.64-11.44l1.6-3.08c.17-.33.32-.59.43-.8A1.18,1.18,0,0,1,140.59,304.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.91,422.16a2,2,0,0,1-.12-.52l-.24-1.49c-.19-1.3-.52-3.18-1-5.48s-1.09-5-1.9-8-1.87-6.24-3.12-9.59-2.65-6.46-4-9.26-2.69-5.24-3.88-7.27-2.17-3.64-2.89-4.74c-.32-.52-.59-.94-.8-1.29s-.27-.45-.25-.46a2.17,2.17,0,0,1,.33.4l.89,1.23c.77,1.07,1.81,2.66,3,4.67s2.59,4.47,4,7.25,2.77,5.93,4,9.29,2.28,6.64,3.09,9.64,1.4,5.75,1.8,8.07.68,4.21.81,5.52c.06.61.1,1.1.14,1.51A2,2,0,0,1,88.91,422.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.35,
    y: 415.54,
    width: 54.29,
    height: 11.07,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.53 426.61 78.4 463.86 111.2 463.86 116.67 426.61 72.53 426.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,426.61c0,.14-10.27.26-22.94.26s-22.93-.12-22.93-.26,10.26-.26,22.93-.26S118.31,426.47,118.31,426.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.66,
    y: 85.11,
    width: 157.43,
    height: 107.31,
    transform: "translate(-14.84 110.95) rotate(-10.18)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.39,205.49,528.52,99.85l-.08.11L683.38,72.17h0l-.14-.1c6.76,37.62,13.19,73.39,19,105.63l.09-.13L547.39,205.49l155-27.71.11,0,0-.11c-5.79-32.24-12.21-68-19-105.63l0-.12-.12,0h0L528.4,99.77l-.09,0,0,.09C539.94,164.25,547.24,204.7,547.39,205.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.14,132.79s0-.12,0-.34-.09-.56-.16-1c-.15-.86-.36-2.1-.64-3.68-.55-3.16-1.34-7.68-2.3-13.12l-.08.12,22.75-4.07s-.27-.19-.14-.09h0v.06l0,.07,0,.16.06.3.11.61c.07.4.14.81.22,1.21.14.8.28,1.6.43,2.39.28,1.58.56,3.13.83,4.65.55,3,1.07,5.93,1.56,8.63l.09-.13-16.39,3-4.66.87-1.24.23-.33.07-.11,0s0,0,.1,0l.32-.05,1.22-.2,4.65-.81,16.48-2.9.1,0,0-.11c-.48-2.7-1-5.6-1.54-8.63-.27-1.52-.55-3.07-.83-4.65-.14-.79-.28-1.59-.43-2.39l-.21-1.21-.11-.61-.06-.31,0-.15v-.13h0l-.15-.1-22.74,4.1-.09,0v.1c1,5.47,1.84,10,2.42,13.17.29,1.57.52,2.79.68,3.65l.18.95C609.12,132.69,609.14,132.79,609.14,132.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.59,104.66,676.7,82.73,691,162.34,568.88,184.26ZM676.33,83.28l-121.2,21.77,14.12,78.67L690.45,162Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.25,
    y: 93.9,
    width: 123.6,
    height: 4.1,
    transform: "translate(1239.35 81.5) rotate(169.82)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.1,
    y: 104.51,
    width: 4.49,
    height: 58.5,
    transform: "translate(1379.58 144.64) rotate(169.82)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.74,
    y: 83.34,
    width: 4.49,
    height: 7.71,
    transform: "translate(1354.76 53.72) rotate(169.82)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.55,103.64l5.89-13.59,1.6.74-5.89,13.59Zm6.13-13-5.52,12.73.75.34L674.42,91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667,122.51l10.61-1.91,2.1,11.7-10.61,1.9Zm10.24-1.36-9.7,1.74,1.94,10.76,9.69-1.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.68,
    y: 168.47,
    width: 123.6,
    height: 4.63,
    transform: "translate(1279.25 227.63) rotate(169.82)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.29,128.11a3.09,3.09,0,1,1,3.6,2.56A3.14,3.14,0,0,1,670.29,128.11Zm.46-.09a2.63,2.63,0,1,0,2.11-3.1A2.66,2.66,0,0,0,670.75,128Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.48,101.84l41.1-7.38,2,11.36-41.1,7.38ZM634.21,95,594,102.22l1.87,10.43,40.19-7.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.57,102.64l4.08-5,4.92,4.2-4.08,5Zm4.14-4.33-3.48,4.27,4.2,3.6,3.49-4.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.15,103.79l4.08-5,4.92,4.2-4.08,5Zm4.14-4.32-3.48,4.26,4.2,3.6,3.49-4.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.73,104.94l4.08-5,4.92,4.21-4.08,5Zm4.15-4.32-3.49,4.27,4.2,3.59,3.49-4.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.13,109.06a3.83,3.83,0,1,1,4.46,3.17A3.87,3.87,0,0,1,584.13,109.06Zm.46-.08a3.36,3.36,0,1,0,2.7-4A3.42,3.42,0,0,0,584.59,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.2,94l17.63-3.17L656.65,101,639,104.15Zm17.25-2.62-16.71,3,1.66,9.23,16.71-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.6,114.81,570.78,113l4.81,26.8-10.18,1.83Zm9.8-1.28-9.26,1.66,4.64,25.87,9.27-1.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.52,
    y: 103.89,
    width: 4.12,
    height: 75.77,
    transform: "translate(1143.35 181.7) rotate(169.82)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.69,130.62l-1.09-6.08a3.18,3.18,0,0,1,2.53-3.71l.74-.13a3.18,3.18,0,0,1,3.66,2.6l1.09,6.08a3.18,3.18,0,0,1-2.53,3.71l-.74.13A3.18,3.18,0,0,1,575.69,130.62Zm1.52-9.32a2.7,2.7,0,0,0-2.15,3.16l1.09,6.08a2.72,2.72,0,0,0,3.12,2.22l.74-.14a2.7,2.7,0,0,0,2.15-3.16l-1.09-6.08a2.72,2.72,0,0,0-3.12-2.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.33,143.22c0,.06,11.56-1.95,25.78-4.51S681.86,134,681.85,134s-11.55,1.94-25.78,4.5S630.32,143.15,630.33,143.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.44,152.94a9.79,9.79,0,0,0-.18-1.49c-.14-.91-.35-2.17-.6-3.55s-.49-2.64-.67-3.54a10.06,10.06,0,0,0-.35-1.45,9.88,9.88,0,0,0,.18,1.48c.14.91.35,2.17.6,3.55s.49,2.64.67,3.54A10.48,10.48,0,0,0,632.44,152.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.86,136.24l13.46-2.42,4.5,25.06-13.46,2.42Zm13.08-1.87-12.54,2.25,4.33,24.13,12.54-2.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.58,107.6c0,.06,5.09-.79,11.33-1.91s11.31-2.09,11.3-2.16-5.09.79-11.34,1.91S539.57,107.53,539.58,107.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.3,194.1c.06,0-3.46-19.95-7.88-44.53s-8-44.51-8.11-44.5,3.46,20,7.88,44.54S555.23,194.12,555.3,194.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.48,187.7c0,.06,4.56-.7,10.16-1.7s10.12-1.88,10.11-1.94-4.56.69-10.16,1.7S549.46,187.63,549.48,187.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.62,191a44,44,0,0,0-.71-4.65c-.46-2.55-.89-4.62-.95-4.61a43.17,43.17,0,0,0,.71,4.65A44.8,44.8,0,0,0,570.62,191Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.68,167.5c0-.07-30.18,5.29-67.37,12S556,191.62,556,191.69s30.16-5.29,67.37-12S690.69,167.57,690.68,167.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.62,169.63a30.47,30.47,0,0,0-.55-3.73,32.16,32.16,0,0,0-.78-3.68,29.2,29.2,0,0,0,.54,3.72A28.59,28.59,0,0,0,691.62,169.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.61,103.61s.13.11.39.27a11.58,11.58,0,0,0,1.12.59,13.77,13.77,0,0,0,4,1.15,16.87,16.87,0,0,0,4.16-.07c.53-.08,1-.15,1.24-.22a1.71,1.71,0,0,0,.44-.12,17,17,0,0,0-1.7.17,18.72,18.72,0,0,1-4.11,0,14.93,14.93,0,0,1-4-1.06C668.21,103.9,667.63,103.57,667.61,103.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.77,165.81l5.88-13.59,1.6.73-5.89,13.59Zm6.12-13-5.51,12.72.74.34,5.52-12.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.82,165.78a2.91,2.91,0,0,0,.39.26c.26.16.64.36,1.12.59a13.45,13.45,0,0,0,4,1.15,16.39,16.39,0,0,0,4.15-.06c.53-.08,1-.16,1.24-.22a1.77,1.77,0,0,0,.45-.13s-.66.07-1.71.17a18.72,18.72,0,0,1-4.11,0,15.14,15.14,0,0,1-4-1.06C626.42,166.06,625.84,165.74,625.82,165.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.92,106.6c.06,0-.29-2.29-.79-5.09s-1-5.07-1-5.06.29,2.29.8,5.1S627.85,106.62,627.92,106.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.62,111.07c.07,0-.29-2.32-.8-5.16s-1-5.12-1-5.11.29,2.32.8,5.16S605.56,111.08,605.62,111.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.22,121.51l27.17-4.88,3.3,18.4-27.17,4.88ZM664,117.18l-26.25,4.71,3.13,17.47,26.26-4.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660,136.09c.07,0-.59-4-1.46-8.84s-1.64-8.81-1.71-8.8.59,4,1.47,8.85S659.9,136.11,660,136.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.68,138.24c.07,0-.59-4-1.46-8.81s-1.63-8.78-1.69-8.77.58,4,1.46,8.81S647.62,138.25,647.68,138.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.89,179.62l-4.16-23.18,42.07-7.56L612,172.07Zm-3-22.41,3.82,21.3,40.19-7.22L607,150Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.05,
    y: 158.2,
    width: 63.18,
    height: 92.68,
    transform: "translate(-124.48 257.25) rotate(-78.69)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,182.64c-.1.47-4.86,24.19-12.45,61.94l.07,0L43,226.36h0l.06.08c4.41-22.06,8.6-43.05,12.38-61.95l-.08,0,90.9,18.1L55.41,164.41h-.07v.06L42.94,226.41l0,.07.07,0h0l90.88,18.15h.05l0,0C141.46,206.84,146.18,183.11,146.28,182.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77,209.15l0,.2-.12.57c-.1.5-.25,1.23-.44,2.15-.38,1.85-.92,4.5-1.57,7.69l.07,0L81.32,217s.11.16.06.08h0V217l0-.09,0-.18.07-.36c0-.24.09-.47.14-.71.1-.47.19-.94.28-1.4.19-.93.37-1.84.55-2.73.35-1.78.69-3.48,1-5.06l-.07.05L93,208.44l2.74.53.73.14.19,0h0l-.18,0-.71-.15-2.72-.56-9.66-2h-.06v.06c-.32,1.59-.66,3.29-1,5.06-.18.89-.36,1.8-.55,2.73-.09.46-.18.93-.28,1.4l-.14.71-.07.36,0,.18v.16h0l.05.08,13.35,2.66h0l0-.06c.62-3.21,1.15-5.87,1.51-7.74.18-.92.32-1.64.41-2.14l.11-.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59,236.33,49,222l9.33-46.69,71.62,14.32Zm-71.3-14.54L120.38,236l9.22-46.14L58.51,175.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.66,
    y: 226.64,
    width: 72.77,
    height: 2.41,
    transform: "translate(46.32 -12.25) rotate(11.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.01,
    y: 175.41,
    width: 2.64,
    height: 34.44,
    transform: "translate(38.86 -7.3) rotate(11.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.55,
    y: 217.66,
    width: 2.64,
    height: 4.54,
    transform: "translate(44.1 -5.7) rotate(11.3)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.49,212.53l-6.16,6.17-.72-.74,6.16-6.18Zm-6.15,5.78,5.76-5.79-.33-.34L52,218Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,202.32l-6.22-1.24L58,194.22l6.22,1.24ZM57,200.86,62.67,202l1.26-6.32-5.69-1.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.43,
    y: 182.59,
    width: 72.77,
    height: 2.73,
    transform: "translate(37.88 -14.82) rotate(11.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,198.54a1.82,1.82,0,1,1-1.42-2.19A1.84,1.84,0,0,1,62.26,198.54Zm-.27-.06a1.54,1.54,0,1,0-1.82,1.25A1.57,1.57,0,0,0,62,198.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,229.49l-24.11-4.82L75.9,218,100,222.82Zm-23.79-5,23.57,4.71L99.69,223l-23.57-4.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.65,223.85l-3.31,1.86-1.79-3.37,3.31-1.85Zm-3.2,1.48,2.83-1.59-1.53-2.87-2.83,1.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.41,224.61l-3.31,1.85-1.78-3.36,3.31-1.86Zm-3.2,1.47L89,224.5l-1.52-2.88-2.83,1.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,225.36l-3.31,1.85-1.79-3.36L91.39,222ZM90,226.84l2.83-1.59-1.53-2.88L88.45,224Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,227.55a2.25,2.25,0,1,1-1.76-2.7A2.29,2.29,0,0,1,105.35,227.55Zm-.27-.06a2,2,0,1,0-2.34,1.6A2,2,0,0,0,105.08,227.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,224.36l-10.34-2.07,1.2-6,10.33,2.07Zm-10-2.29,9.8,2,1.08-5.41-9.8-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,229.47l-6-1.19,3.14-15.72,6,1.19Zm-5.64-1.41,5.43,1.09,3-15.18-5.43-1.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.45,
    y: 191.75,
    width: 2.43,
    height: 44.61,
    transform: "translate(44.36 -20.09) rotate(11.3)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,217.56l-.71,3.56a1.87,1.87,0,0,1-2.18,1.49l-.44-.09a1.87,1.87,0,0,1-1.44-2.21l.71-3.57a1.88,1.88,0,0,1,2.19-1.49l.43.09A1.87,1.87,0,0,1,114.62,217.56Zm-2.84,4.78a1.59,1.59,0,0,0,1.86-1.27l.72-3.57a1.6,1.6,0,0,0-1.23-1.89l-.44-.08a1.6,1.6,0,0,0-1.86,1.27l-.71,3.56a1.6,1.6,0,0,0,1.23,1.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.41,198.87s-6.75-1.42-15.09-3.09-15.12-3-15.13-2.95,6.75,1.43,15.1,3.09S87.4,198.91,87.41,198.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.35,193.09a6.05,6.05,0,0,0-.22.86c-.12.53-.27,1.26-.44,2.07s-.3,1.55-.39,2.09a6.43,6.43,0,0,0-.13.87,4.89,4.89,0,0,0,.23-.85c.12-.53.27-1.27.43-2.08s.3-1.55.4-2.08A5.58,5.58,0,0,0,88.35,193.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.35,194.61,57.45,193l2.94-14.7,7.89,1.58Zm-7.57-1.8,7.35,1.47L68,180.13l-7.35-1.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44,238s-3-.66-6.62-1.39-6.64-1.3-6.65-1.26,3,.67,6.62,1.4S129.44,238,129.44,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,187.18s-2.41,11.67-5.29,26.09-5.19,26.12-5.15,26.13,2.4-11.68,5.29-26.1S139.52,187.18,139.49,187.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29,191.94s-2.64-.6-5.93-1.26-6-1.16-6-1.12,2.65.61,5.93,1.26S141.29,192,141.29,191.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.42,185.59a25.09,25.09,0,0,0-.62,2.7,25.81,25.81,0,0,0-.47,2.73,26.74,26.74,0,0,0,.61-2.7A27.66,27.66,0,0,0,130.42,185.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.59,172.56s17.67,3.61,39.48,8,39.51,7.86,39.52,7.82-17.67-3.6-39.49-8S59.6,172.52,59.59,172.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.53,171.19a18,18,0,0,0-.5,2.16,20.11,20.11,0,0,0-.37,2.19,16.86,16.86,0,0,0,.51-2.16A16.39,16.39,0,0,0,59.53,171.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.45,212.53s-.05-.09-.16-.23a7.13,7.13,0,0,0-.48-.56,8.24,8.24,0,0,0-2-1.5,9.68,9.68,0,0,0-2.3-.86l-.72-.15a1.09,1.09,0,0,0-.27,0s.37.1,1,.27a11.49,11.49,0,0,1,2.25.89,8.63,8.63,0,0,1,1.94,1.44C58.18,212.25,58.43,212.55,58.45,212.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,187.48l-6.15,6.18-.72-.75,6.16-6.17Zm-6.15,5.78,5.77-5.78-.34-.35-5.76,5.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,187.49s0-.09-.15-.23a7.47,7.47,0,0,0-.49-.57,7.84,7.84,0,0,0-1.95-1.49,9.63,9.63,0,0,0-2.29-.86l-.73-.15a.91.91,0,0,0-.27,0,9.31,9.31,0,0,0,1,.28,11,11,0,0,1,2.25.89,8.72,8.72,0,0,1,2,1.44C94.48,187.2,94.72,187.5,94.74,187.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.84,219.45s-.34,1.32-.67,3a30.35,30.35,0,0,0-.52,3s.33-1.32.66-3S80.88,219.46,80.84,219.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,221.81s-.34,1.34-.67,3-.57,3-.53,3,.34-1.33.67-3S94.05,221.82,94,221.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,209.28,63,206.1l2.16-10.8,15.94,3.19Zm-15.62-3.4L78.74,209l2.05-10.24-15.4-3.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,196.38s-.53,2.31-1.11,5.16-1,5.18-1,5.19.53-2.3,1.1-5.16S69.68,196.39,69.64,196.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.83,197.86s-.53,2.29-1.1,5.14-1,5.16-1,5.17.53-2.29,1.1-5.14S76.87,197.87,76.83,197.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.82,205.82l-25.1-5,2.8-14,25.11,5ZM101.9,200,125,204.64l2.41-12.06L104.31,188Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.32,
    y: 61.5,
    width: 283.39,
    height: 402.24,
    rx: 11.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,463.74l.88-.06a12.41,12.41,0,0,0,2.55-.49,11.92,11.92,0,0,0,3.75-2,11.48,11.48,0,0,0,3.43-4.73,10.93,10.93,0,0,0,.75-3.46c.06-1.25,0-2.58,0-4,0-2.78,0-5.81,0-9.1,0-6.59,0-14.18,0-22.73,0-34.2-.05-83.69-.08-144.83,0-30.57,0-64.06,0-100q0-27,0-55.72,0-14.37,0-29.14,0-7.38,0-14.86a11.15,11.15,0,0,0-2.52-6.75A11.35,11.35,0,0,0,507.74,62a15.29,15.29,0,0,0-3.72-.28H244.8A11.16,11.16,0,0,0,233.62,72.4c-.06,5.77,0,11.57,0,17.32V191.16c0,44,0,86.44,0,126.86s0,78.85,0,114.8q0,6.75,0,13.37c0,2.2,0,4.42,0,6.59a11.16,11.16,0,0,0,2,6,11.27,11.27,0,0,0,4.89,3.91,11.93,11.93,0,0,0,3,.78c1,.09,2.11.07,3.18.07h12.64l48,0,144.82.08,39.37.05,10.24,0,3.49,0-3.49,0-10.24,0-39.37.06-144.82.08-48,0H246.71c-1.07,0-2.13,0-3.22-.07a12.4,12.4,0,0,1-3.17-.8,11.82,11.82,0,0,1-5.08-4.07,11.62,11.62,0,0,1-2.12-6.22c-.05-2.2,0-4.39,0-6.6V432.82c0-35.95,0-74.37,0-114.8s0-82.86,0-126.86V124.05q0-17,0-34.33c0-5.76,0-11.52,0-17.35A11.73,11.73,0,0,1,244.8,61.23H504a15.94,15.94,0,0,1,3.83.3,11.63,11.63,0,0,1,9.09,11q0,7.48,0,14.87,0,14.78,0,29.14,0,28.72,0,55.72c0,36,0,69.44,0,100,0,61.14-.07,110.63-.09,144.83,0,8.55,0,16.14,0,22.73,0,3.29,0,6.32,0,9.1,0,1.39,0,2.71,0,4a11.12,11.12,0,0,1-.76,3.49,11.63,11.63,0,0,1-3.49,4.76,11.82,11.82,0,0,1-3.78,2,12.33,12.33,0,0,1-2.57.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "260.2 453.75 497.84 452.45 500.56 406.54 493.28 378.85 258.04 415.6 260.2 453.75"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,463.74l.88-.06a12.41,12.41,0,0,0,2.55-.49,11.92,11.92,0,0,0,3.75-2,11.48,11.48,0,0,0,3.43-4.73,10.93,10.93,0,0,0,.75-3.46c.06-1.25,0-2.58,0-4,0-2.78,0-5.81,0-9.1,0-6.59,0-14.18,0-22.73,0-34.2-.05-83.69-.08-144.83,0-30.57,0-64.06,0-100q0-27,0-55.72,0-14.37,0-29.14,0-7.38,0-14.86a11.15,11.15,0,0,0-2.52-6.75A11.35,11.35,0,0,0,507.74,62a15.29,15.29,0,0,0-3.72-.28H244.8A11.16,11.16,0,0,0,233.62,72.4c-.06,5.77,0,11.57,0,17.32V191.16c0,44,0,86.44,0,126.86s0,78.85,0,114.8q0,6.75,0,13.37c0,2.2,0,4.42,0,6.59a11.16,11.16,0,0,0,2,6,11.27,11.27,0,0,0,4.89,3.91,11.93,11.93,0,0,0,3,.78c1,.09,2.11.07,3.18.07h12.64l48,0,144.82.08,39.37.05,10.24,0,3.49,0-3.49,0-10.24,0-39.37.06-144.82.08-48,0H246.71c-1.07,0-2.13,0-3.22-.07a12.4,12.4,0,0,1-3.17-.8,11.82,11.82,0,0,1-5.08-4.07,11.62,11.62,0,0,1-2.12-6.22c-.05-2.2,0-4.39,0-6.6V432.82c0-35.95,0-74.37,0-114.8s0-82.86,0-126.86V124.05q0-17,0-34.33c0-5.76,0-11.52,0-17.35A11.73,11.73,0,0,1,244.8,61.23H504a15.94,15.94,0,0,1,3.83.3,11.63,11.63,0,0,1,9.09,11q0,7.48,0,14.87,0,14.78,0,29.14,0,28.72,0,55.72c0,36,0,69.44,0,100,0,61.14-.07,110.63-.09,144.83,0,8.55,0,16.14,0,22.73,0,3.29,0,6.32,0,9.1,0,1.39,0,2.71,0,4a11.12,11.12,0,0,1-.76,3.49,11.63,11.63,0,0,1-3.49,4.76,11.82,11.82,0,0,1-3.78,2,12.33,12.33,0,0,1-2.57.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.2 453.75 497.84 452.45 500.56 406.54 493.28 378.85 258.04 415.6 260.2 453.75"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 247.66,
    y: 77.71,
    width: 254.7,
    height: 367.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.37,444.74c0-2.11-.1-150.42-.24-367l.24.23L247.69,78h0l.26-.26c0,137.83,0,265.18,0,367l-.21-.21,254.71.21L247.66,445h-.21v-.21c0-101.85,0-229.2,0-367v-.26h.29l254.68,0h.23v.24C502.46,294.32,502.37,442.63,502.37,444.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 98.26,
    width: 127.75,
    height: 11.8,
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 125.86,
    width: 55.71,
    height: 11.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 146.86,
    width: 111.66,
    height: 11.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.97,
    y: 163.23,
    width: 111.66,
    height: 11.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 162.99,
    width: 53.12,
    height: 11.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.99,
    y: 146.49,
    width: 53.12,
    height: 11.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.01,
    y: 146.49,
    width: 40.41,
    height: 11.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.01,
    y: 163.19,
    width: 40.41,
    height: 11.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 341.47,
    width: 220.34,
    height: 13.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 183.8,
    width: 220.34,
    height: 13.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 278.14,
    width: 87.88,
    height: 13.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.87,
    y: 278.14,
    width: 109.87,
    height: 13.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.8,299.77c0,.16-19.66.28-43.9.28s-43.9-.12-43.9-.28,19.65-.29,43.9-.29S349.8,299.61,349.8,299.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,310.09c0,.16-19.33.28-43.17.28s-43.17-.12-43.17-.28,19.32-.29,43.17-.29S348.34,309.93,348.34,310.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.08,320.58c0,.15-19.49.28-43.54.28s-43.54-.13-43.54-.28,19.49-.29,43.54-.29S349.08,320.42,349.08,320.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.08,330.76c0,.16-19.49.28-43.54.28s-43.54-.12-43.54-.28,19.49-.29,43.54-.29S349.08,330.6,349.08,330.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,302.19c0,.16-20.36.28-45.47.28s-45.47-.12-45.47-.28,20.36-.28,45.47-.28S483,302,483,302.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,305.48a15.77,15.77,0,0,1-.12-1.89c0-1.16-.09-2.77-.12-4.69l.24.24-6.26,0,.27-.28h0v3.47c0,1.09,0,2.13,0,3.1l-.24-.25c1.83,0,3.37.08,4.47.13a14.47,14.47,0,0,1,1.8.12,9.54,9.54,0,0,1-1.65.12c-1.09,0-2.69.1-4.62.12h-.23v-.25c0-1,0-2,0-3.1v-3.47h0l.28-.29,6.26,0h.23v.25c0,2-.07,3.7-.12,4.85A11.44,11.44,0,0,1,385.12,305.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,314.83c0,.16-20.36.28-45.47.28s-45.47-.12-45.47-.28,20.36-.29,45.47-.29S483,314.67,483,314.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,318.12a15.77,15.77,0,0,1-.12-1.89c0-1.16-.09-2.77-.12-4.69l.24.24-6.26,0,.27-.28h0V315c0,1.1,0,2.14,0,3.11l-.24-.25c1.83,0,3.37.08,4.47.13a14.47,14.47,0,0,1,1.8.12,9.54,9.54,0,0,1-1.65.12c-1.09.05-2.69.1-4.62.12h-.23v-.25c0-1,0-2,0-3.11v-3.46h0l.28-.29,6.26,0h.23v.25c0,2-.07,3.7-.12,4.85A11.44,11.44,0,0,1,385.12,318.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,327.47c0,.16-20.36.28-45.47.28s-45.47-.12-45.47-.28,20.36-.29,45.47-.29S483,327.31,483,327.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,330.76a15.77,15.77,0,0,1-.12-1.89c0-1.16-.09-2.77-.12-4.69l.24.24-6.26,0,.27-.28h0v3.46c0,1.1,0,2.14,0,3.11l-.24-.25c1.83,0,3.37.08,4.47.13a14.47,14.47,0,0,1,1.8.12,9.54,9.54,0,0,1-1.65.12c-1.09.05-2.69.1-4.62.12h-.23v-.25c0-1,0-2,0-3.11v-3.46h0l.28-.29,6.26,0h.23v.25c0,2-.07,3.7-.12,4.85A11.44,11.44,0,0,1,385.12,330.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,268.2s0-.37,0-1.08,0-1.76,0-3.14c0-2.78,0-6.87,0-12.19,0-10.64,0-26.18-.09-45.83l.17.18-217,.11h0l.27-.29c0,21.42,0,42.29,0,62.24l-.26-.28,154.94.13,45.51.08,12.24,0h3.18l1.09,0-1.06,0-3.14,0-12.18,0-45.45.08-155.13.13H262v-62.8h.28l217,.11h.16V206c0,19.69-.07,35.27-.09,45.93,0,5.3,0,9.39,0,12.15,0,1.37,0,2.41,0,3.12S479.23,268.2,479.23,268.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,221.63c0,.15-48.44.28-108.18.28s-108.18-.13-108.18-.28,48.43-.29,108.18-.29S479.23,221.47,479.23,221.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,237.08c0,.16-48.44.29-108.18.29s-108.18-.13-108.18-.29,48.43-.28,108.18-.28S479.23,236.92,479.23,237.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,252.71c0,.15-48.44.28-108.18.28s-108.18-.13-108.18-.28,48.43-.29,108.18-.29S479.23,252.55,479.23,252.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.48,268.75c-.14,0-.27-14.08-.27-31.45s.13-31.44.27-31.44.27,14.08.27,31.44S287.63,268.75,287.48,268.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.85,266.85c-.15,0-.27-13.44-.27-30s.12-30,.27-30,.27,13.44.27,30S361,266.85,360.85,266.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,269.69c-.15,0-.27-13.87-.27-31s.12-31,.27-31,.27,13.87.27,31S438.31,269.69,438.16,269.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.91,130.69c0,.15-33.13.26-74,.26s-74-.11-74-.26,33.12-.26,74-.26S476.91,130.55,476.91,130.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.41,135.94c0,.15-9.73.26-21.74.26s-21.74-.11-21.74-.26,9.73-.26,21.74-.26S372.41,135.8,372.41,135.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.89,366.32c0,.15-39.38.26-87.94.26s-87.95-.11-87.95-.26,39.36-.26,87.95-.26S437.89,366.18,437.89,366.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.92,375.15a1.7,1.7,0,0,1-.37,0l-1.08,0-4.16.05-15.32.08-50.53.08-50.53-.08-15.32-.08-4.16-.05-1.09,0a1.65,1.65,0,0,1-.36,0l.36,0,1.09,0,4.16-.05,15.32-.09,50.53-.07L384,375l15.32.09,4.16.05,1.08,0A1.7,1.7,0,0,1,404.92,375.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,384a8,8,0,0,1-.85,0l-2.43.05-8.93.08-29.49.08-29.48-.08-8.94-.08-2.43-.05a7.91,7.91,0,0,1-.84,0,4.6,4.6,0,0,1,.84-.06l2.43-.05,8.94-.08,29.48-.07,29.49.07,8.93.08,2.43.05A4.67,4.67,0,0,1,345.39,384Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,404.77c0,.15-13.15.27-29.37.27s-29.37-.12-29.37-.27,13.15-.28,29.37-.28S333.06,404.61,333.06,404.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.78,427.43s.18-.33.47-1a7,7,0,0,0,.51-3,28.57,28.57,0,0,0-.79-4.85,15.26,15.26,0,0,1-.4-6.57,9.72,9.72,0,0,1,4.83-6.23,9.22,9.22,0,0,1,9,.31,9,9,0,0,1,3.49,3.6,4.32,4.32,0,0,1,.44,2.64,2.33,2.33,0,0,1-2,1.85,18.72,18.72,0,0,1-2.69.06l-2.69,0c-1.8,0-3.64-.12-5.49-.29a39.78,39.78,0,0,1-10.6-2.3c-1.62-.54-3.36-.95-4.82-.27s-2.43,2.07-3.64,3.15a4.55,4.55,0,0,1-2.17,1.21,3.3,3.3,0,0,1-2.39-.43,21.51,21.51,0,0,1-3.3-3,4.63,4.63,0,0,0-1.66-1.1,2.7,2.7,0,0,0-1.84,0,10.44,10.44,0,0,0-2.83,2.39,7,7,0,0,1-6.16,1.93,6.6,6.6,0,0,1-4.18-2.61,6.77,6.77,0,0,1-1.24-2.89,4.28,4.28,0,0,1-.06-1.09s0,.38.17,1.07a7.1,7.1,0,0,0,1.3,2.78,6.46,6.46,0,0,0,4.06,2.44,6.73,6.73,0,0,0,5.84-1.91,10.54,10.54,0,0,1,2.94-2.5,3.08,3.08,0,0,1,2.14-.08,5.06,5.06,0,0,1,1.83,1.18,21.82,21.82,0,0,0,3.23,2.93,2.84,2.84,0,0,0,2.05.36,4.07,4.07,0,0,0,1.92-1.1c1.17-1,2.13-2.48,3.77-3.26a5.05,5.05,0,0,1,2.63-.37,12.61,12.61,0,0,1,2.58.62,39.43,39.43,0,0,0,10.48,2.26c1.83.16,3.66.24,5.46.29l2.68,0a20.07,20.07,0,0,0,2.59-.05,1.77,1.77,0,0,0,1.57-1.42,3.85,3.85,0,0,0-.38-2.3,8.5,8.5,0,0,0-3.28-3.39,8.77,8.77,0,0,0-8.48-.35A9.38,9.38,0,0,0,455,412.1a15.19,15.19,0,0,0,.32,6.41,27,27,0,0,1,.71,4.92,6.75,6.75,0,0,1-.63,3.07A4.91,4.91,0,0,1,454.78,427.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.22,416.83a5.61,5.61,0,0,1-.72.05l-2.06,0-7.59.07c-6.41,0-15.26.17-25,.46s-18.63.68-25,1l-7.58.37-2.06.09a3.61,3.61,0,0,1-.72,0,3.64,3.64,0,0,1,.71-.1l2.06-.19c1.78-.16,4.37-.35,7.57-.56,6.4-.42,15.25-.87,25-1.16s18.64-.34,25.05-.3c3.21,0,5.8.07,7.59.12l2.07.06A3.56,3.56,0,0,1,485.22,416.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.25,51.48H440.2a6.33,6.33,0,0,1,6.33,6.33V89.36a0,0,0,0,1,0,0H315.92a0,0,0,0,1,0,0V57.81A6.33,6.33,0,0,1,322.25,51.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.84 37.24 364.61 37.24 368.49 65.73 393.53 65.73 397.84 37.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.13,51.48c0,.16-25.48.28-56.9.28s-56.92-.12-56.92-.28,25.48-.27,56.92-.27S438.13,51.33,438.13,51.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.85,83.25c-.15,0-.28-5.36-.28-12s.13-12,.28-12,.27,5.36.27,12S319,83.25,318.85,83.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.3,80.42A104,104,0,0,1,442,69.55a103.72,103.72,0,0,1,.28-10.86c.15,0,.27,4.86.27,10.86S442.45,80.42,442.3,80.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,85.46c0,.15-26.16.27-58.42.27s-58.42-.12-58.42-.27,26.15-.28,58.42-.28S436,85.31,436,85.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.52 62.32 451.93 78.35 451.93 86.21 445.83 86.21 446.52 62.32"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 254.135712, -22.884258)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -265.366913, 50.881565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 299.273 381.847 C 294.473 381.834 290.283 376.996 289.068 370.065 L 282.815 334.587 C 281.346 326.185 284.698 317.59 290.319 315.355 L 451.646 252.579 C 457.27 250.374 463.027 255.388 464.514 263.783 L 470.705 299.26 C 472.195 307.66 468.832 316.272 463.202 318.473 L 301.874 381.268 C 301.025 381.615 300.152 381.809 299.273 381.847 Z M 454.435 257.658 C 453.852 257.658 453.272 257.772 452.708 257.994 L 291.382 320.789 C 289.628 321.446 288.13 323.138 287.23 325.475 C 286.311 327.793 286.05 330.562 286.505 333.168 L 292.757 368.645 C 293.707 374.066 297.414 377.322 301.049 375.928 L 462.376 313.133 C 465.957 311.666 468.085 306.176 467.153 300.81 L 460.9 265.333 C 460.125 260.851 457.42 257.72 454.322 257.714 L 454.435 257.658 Z",
    style: {
      fill: "rgb(0, 171, 101)",
      mixBlendMode: "darken"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 221.530487, -54.012733)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.655865, -13.307485)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2.814204, -0.703551)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 171, 101)",
      fontFamily: "Poppins",
      fontSize: 22,
      fontWeight: 700,
      whiteSpace: "pre",
      transformBox: "fill-box",
      transformOrigin: "66.0919% 54.1123%",
      textAnchor: "middle"
    },
    transform: "matrix(0.927184, -0.374607, 0.374607, 0.927184, -170.543381, 43.095379)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 308.833,
    y: 329.292,
    style: {
      fontSize: 22,
      wordSpacing: 0
    }
  }, "NO "), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontSize: 22,
      wordSpacing: 0
    }
  }, "APPROVAL", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 308.8330078125,
    dy: "1em"
  }, "\u200B")), "YET")))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.12,86.77a28,28,0,1,0,11,40l7.79-1.46-4.43-6.12A28,28,0,0,0,98.12,86.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.12,86.77l.61.31c.4.23,1,.53,1.78,1a28.65,28.65,0,0,1,5.93,5,23.88,23.88,0,0,1,1.67,2c.28.38.56.76.84,1.16s.51.84.78,1.27a27.43,27.43,0,0,1,1.47,2.81c.23.5.42,1,.63,1.55l.31.81.26.84a28.33,28.33,0,0,1,.29,15.73l0-.18,4.43,6.1.21.29-.35.07L109.17,127l.15-.11a28.58,28.58,0,0,1-13.87,11.3,28.14,28.14,0,0,1-19.35.18,29.83,29.83,0,0,1-8.23-4.53,28.85,28.85,0,0,1-6.09-6.8c-.38-.64-.83-1.25-1.15-1.92l-1-2A31.62,31.62,0,0,1,58.23,119a28,28,0,0,1,.58-16.28l.31-.93c.11-.3.25-.59.38-.89l.78-1.75c.3-.56.62-1.1.93-1.64a12.19,12.19,0,0,1,1-1.57,27.86,27.86,0,0,1,10-9A28.69,28.69,0,0,1,83,83.76a29.65,29.65,0,0,1,4.6,0,29,29,0,0,1,3.82.59c.56.14,1.1.24,1.6.38l1.37.46,1.17.4.93.42,1.26.59c.28.13.42.21.42.21l-.45-.16-1.27-.54-.94-.4-1.17-.37-1.37-.44c-.49-.13-1-.22-1.59-.35a29.17,29.17,0,0,0-3.8-.54,30.55,30.55,0,0,0-4.55.08,28.39,28.39,0,0,0-10.56,3.19,27.49,27.49,0,0,0-9.87,8.92,12.8,12.8,0,0,0-1,1.54c-.3.54-.62,1.07-.91,1.62s-.51,1.15-.76,1.73c-.13.29-.27.58-.38.87l-.3.92a27.7,27.7,0,0,0-.53,16,32.49,32.49,0,0,0,1.4,4.06l1,2c.31.66.76,1.25,1.13,1.89a28.2,28.2,0,0,0,6,6.66,29.1,29.1,0,0,0,8.07,4.45,27.73,27.73,0,0,0,19-.17,28.15,28.15,0,0,0,13.65-11.07l.06-.09.1,0,7.79-1.45-.14.36-4.42-6.12-.06-.08,0-.1a28,28,0,0,0-.21-15.52l-.24-.83c-.11-.27-.21-.54-.31-.8-.21-.52-.38-1-.61-1.54a28,28,0,0,0-1.43-2.79c-.26-.43-.5-.86-.76-1.27l-.82-1.15a25.81,25.81,0,0,0-1.64-2,30.15,30.15,0,0,0-5.82-5c-.75-.47-1.35-.79-1.74-1S98.12,86.77,98.12,86.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.44 113.5 75.24 109.41 83.11 115.89 97.53 100.95 101.34 104.76 82.83 123.53 71.44 113.5",
    style: {
      fill: "#00AB65"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.9,422.05l-6.46,22.69S186,459,185.24,463.33l-43.87-11.12L150,416.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,439.38a1.85,1.85,0,0,0-1.75,1.75,1.8,1.8,0,0,0,1.7,1.78,2,2,0,0,0,1.85-1.87c-.09-.92-1.1-1.87-2-1.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.37,452.21l1-3.57,41.68,12s1.74,1.35,1.18,2.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.21,444.69c-.06.22-1.16.05-2.39.48s-2,1.2-2.18,1.06.45-1.31,1.94-1.8S166.3,444.51,166.21,444.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,447.79c0,.22-1,.36-2,1.09s-1.41,1.65-1.62,1.59,0-1.33,1.16-2.22S170.38,447.58,170.33,447.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57,454c-.21,0-.24-1.16.6-2.21s2-1.27,2-1.07-.73.69-1.41,1.56S171.79,454.06,171.57,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.11,439.36c-.13.17-1-.38-2.28-.6s-2.27-.08-2.33-.29,1-.76,2.48-.47S167.26,439.21,167.11,439.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53,427.39l-1,23.6s23.32,9,23.56,13.35L133.84,464l.1-36.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,448.89a1.87,1.87,0,0,0-1.29,2.13,1.77,1.77,0,0,0,2.06,1.31,2,2,0,0,0,1.36-2.25,1.83,1.83,0,0,0-2.3-1.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.84,464l.16-3.71L177.3,462s2,.9,1.77,2.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,450.76c0,.22-1.11.32-2.2,1s-1.68,1.64-1.88,1.55.13-1.38,1.47-2.21S156.29,450.55,156.24,450.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,452.78c.05.22-.91.59-1.67,1.54s-1,1.93-1.2,1.92-.35-1.27.61-2.43S161,452.57,161,452.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.62,458.56c-.2,0-.5-1.08.08-2.3s1.61-1.7,1.7-1.51-.55.84-1,1.85S163.84,458.54,163.62,458.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.89,445.36c-.1.2-1.11-.12-2.36,0s-2.22.47-2.34.27.83-1,2.3-1S156,445.18,155.89,445.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,254.74V273.4l4.94,72.68s-3.07,35.26-5,55.16c-1.64,17.28,1,47.38,1,47.38h28.78l10.3-100.38L175,285.63l11.12-28.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.25,254.74,202,330.5c-.19,14.21-4.11,40.75-9.19,54l-23.12,50.81-1.34,4.57-17.2-4.21L164,256Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.34,274.81a2.56,2.56,0,0,1,0,.45c0,.33,0,.77,0,1.33,0,1.2,0,2.92,0,5.12,0,4.44,0,10.87-.14,18.81s-.38,17.4-1,27.9-1.32,22.06-3.78,34c-2.27,11.91-4.69,23.21-6.83,33.49s-4,19.54-5.45,27.36-2.42,14.16-3,18.56c-.33,2.2-.5,3.91-.67,5.07-.07.56-.13,1-.18,1.32a2.28,2.28,0,0,1-.08.44,2.55,2.55,0,0,1,0-.45l.12-1.32c.13-1.17.27-2.89.57-5.09.52-4.41,1.46-10.77,2.83-18.6s3.21-17.11,5.33-27.4,4.52-21.58,6.79-33.49c2.46-11.87,3.17-23.41,3.82-33.88s.87-19.94,1.06-27.88.27-14.36.32-18.8c0-2.2.05-3.92.06-5.12,0-.56,0-1,0-1.33A2.56,2.56,0,0,1,179.34,274.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,230.72a12.89,12.89,0,0,1,.43,4.36c-.21,2.23-.32,7.72-6.27,9.6s-11.56-2.59-13.38-4.61-1.61-8.61-1.61-8.61l9.78-4.36Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.55,146.76l-5,8-20,8.54,5,82.33,3.6,14.91,66.78-2.22,2.94-5-5-63.33c-1.51-14.25-4.71-21.87-11.09-25.37l-4.17-2.86-1.58-5.23L174.18,151l-18.85-4.89Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.34,239.32a20.5,20.5,0,0,0,20.18,9c6.71-1.13,12.36-5.56,18.79-7.77,11.19-3.85,23.95-.79,35-5.08.22-1.9.09-4.23.22-5.53-5.53-.28-11.4-.59-16.27-3.19l-4.43-1.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,163.26s-9.52,8.15-6.76,29.38c2.56,19.73,7.1,47.22,13.16,50.41s19.13,1.59,28.69-3.83,37.31-20.09,37.31-20.09l-11.48-20.4-37,14.34s-4.78-32.72-7.65-38.36",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,174.71s.11.21.29.63c.09.21.21.46.33.78l.36,1.12c.55,1.69,1.19,4.24,1.9,7.54,1.43,6.62,3.15,16.26,5,28.27l-.27-.16,37-14.4.2-.08.11.19,11.5,20.4.13.24-.24.13-23.72,12.78-11.63,6.26c-1.91,1-3.81,2.1-5.79,3a48.1,48.1,0,0,1-6.05,2.09,39.71,39.71,0,0,1-12.33,1.43,17.8,17.8,0,0,1-5.93-1.25l-.7-.31a5.13,5.13,0,0,1-.66-.41,6.55,6.55,0,0,1-1.08-1.09,14.34,14.34,0,0,1-1.56-2.51,56.05,56.05,0,0,1-3.71-10.71c-.93-3.55-1.67-7-2.33-10.41-1.31-6.75-2.29-13.09-3.1-18.88s-1.52-11.06-1.31-15.73a39.11,39.11,0,0,1,2.1-11.71,26,26,0,0,1,3.51-6.66,13.52,13.52,0,0,1,1.27-1.5,4.26,4.26,0,0,1,.49-.45s-.16.16-.45.49a16.33,16.33,0,0,0-1.22,1.52,26.37,26.37,0,0,0-3.39,6.67,39.05,39.05,0,0,0-2,11.65c-.18,4.64.55,9.88,1.39,15.67s1.83,12.1,3.16,18.84c.67,3.37,1.41,6.84,2.35,10.38a56.23,56.23,0,0,0,3.69,10.59,14.75,14.75,0,0,0,1.51,2.43,7.2,7.2,0,0,0,1,1,5.8,5.8,0,0,0,.59.36l.66.29a17.36,17.36,0,0,0,5.76,1.2,39.3,39.3,0,0,0,12.16-1.42,48,48,0,0,0,6-2.08c2-.84,3.81-1.89,5.74-2.92l11.63-6.27,23.73-12.77-.11.38-11.46-20.42.31.12-37,14.29-.24.09,0-.25c-1.77-12-3.44-21.65-4.79-28.27-.68-3.31-1.29-5.86-1.8-7.56-.12-.42-.23-.8-.33-1.12l-.3-.79C139.89,174.93,139.82,174.71,139.82,174.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.01 186.81 167.03 185.23 172.34 195.22 145.42 200.06 143.01 186.81",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,186.81a8.67,8.67,0,0,1,.22,1c.13.66.31,1.55.54,2.66.45,2.33,1.08,5.6,1.86,9.59l-.25-.17,24.24-4.42,2.68-.48-.2.4c-1.86-3.52-3.65-6.88-5.3-10l.25.14-17.21,1-5,.26-1.35.06H143a1.91,1.91,0,0,1,.42-.06l1.29-.11,4.92-.4L167,185h.17l.08.15c1.66,3.11,3.45,6.47,5.33,10l.18.33-.38.07-2.68.48-24.25,4.3-.21,0,0-.21c-.69-4.07-1.25-7.4-1.66-9.77-.17-1.1-.32-2-.42-2.63A7.17,7.17,0,0,1,143,186.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.47,213.07c.15.12-2,2.65-3.79,6.26s-2.56,6.84-2.74,6.79a7.12,7.12,0,0,1,.39-2.13,27.29,27.29,0,0,1,1.85-4.91,25.47,25.47,0,0,1,2.81-4.42A7.58,7.58,0,0,1,147.47,213.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,167.31a8.93,8.93,0,0,1-1.33-1l-3.48-2.76.3-.05a32.15,32.15,0,0,1-4.77,6l-.17.17-.19-.16-3.68-3.05c-3.95-3.23-7.63-6-10.32-8l-3.19-2.35a5.9,5.9,0,0,1-1.13-.91,7.72,7.72,0,0,1,1.26.74c.78.5,1.91,1.25,3.29,2.21,2.75,1.91,6.48,4.65,10.44,7.89,1.29,1,2.53,2.09,3.68,3.08H162a34.92,34.92,0,0,0,4.79-5.82l.13-.2.18.15,3.36,2.91A8.06,8.06,0,0,1,171.6,167.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.48,162.26a4,4,0,0,1,.2,1.33,20.88,20.88,0,0,1-.12,3.56l-.08.63-.37-.53a41.77,41.77,0,0,0-2.85-3.69c-.43-.5-.86-1-1.29-1.42-.2-.21-.44-.47-.61-.63s-.2-.14-.38.06c-.63.89-1.23,1.72-1.77,2.47a14.84,14.84,0,0,1-1.75,2.21,14.31,14.31,0,0,1,1.43-2.43l1.68-2.55a.8.8,0,0,1,.49-.36.79.79,0,0,1,.62.18c.28.24.45.44.69.67.43.45.88.93,1.31,1.43a32.76,32.76,0,0,1,2.84,3.8l-.44.1C181.51,164.22,181.36,162.26,181.48,162.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.72,171.48a11.8,11.8,0,0,1-1.49-1.77,19.23,19.23,0,0,0-3.94-3.81,12.8,12.8,0,0,0-5-2,15.31,15.31,0,0,1-2.28-.35,7,7,0,0,1,2.33,0,11.65,11.65,0,0,1,5.32,1.91,16.54,16.54,0,0,1,3.94,4A7.65,7.65,0,0,1,138.72,171.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,186.22a26.16,26.16,0,0,1-1.9-5.12,26.17,26.17,0,0,1-1.37-5.28,27.77,27.77,0,0,1,1.9,5.12A27.89,27.89,0,0,1,190.92,186.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.78,193.81a1.29,1.29,0,1,0,.31-.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.41 179.61 148.15 199.57 170.36 195.58 148.94 203.97 147.15 210.89 141.41 179.61"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.21,155.6l19.86,18,3.07-8.4,3.22,1.07-3.44-2.85s-3.78,5.8-4.79,5.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.05,198.64a5.47,5.47,0,0,1-.41-1.21c-.25-.9-.56-2-.94-3.33-.79-2.82-1.93-6.69-3.33-10.93s-2.8-8-3.84-10.75l-1.23-3.24a5.55,5.55,0,0,1-.4-1.21,5.69,5.69,0,0,1,.59,1.13c.36.74.84,1.82,1.41,3.17,1.13,2.7,2.59,6.48,4,10.73s2.49,8.15,3.18,11c.35,1.42.61,2.58.77,3.38A5.88,5.88,0,0,1,182.05,198.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,176.47C185.51,180.22,195,190,195,190l2.54-1.53-13.41-14.31a1.66,1.66,0,0,0-2.15-.25h0A1.67,1.67,0,0,0,181.76,176.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.46,198.73l3.2-9a5.05,5.05,0,0,1,4.61-3.46,3.85,3.85,0,0,1,.48,0c1.91.21,11.69.85,11.69.85l3.79,4.24a2,2,0,0,1,0,2.56h0l1.08,7.66-2.14,1.45.21,5.35s-1.92,1.27-2.77.85l-.85-.43-1.27-1.27-3.61,5.1-5,2.89Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.28,194.35a15.22,15.22,0,0,0-1.37-1.49,6.38,6.38,0,0,0-1.82-1.1,14.9,14.9,0,0,0-2.65-.36,45.15,45.15,0,0,1-7-.93,45.56,45.56,0,0,1,7,.38,12.42,12.42,0,0,1,2.77.43,6.13,6.13,0,0,1,1.92,1.29A3.24,3.24,0,0,1,208.28,194.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,201.39a14.8,14.8,0,0,0-.79-2,7.56,7.56,0,0,0-3.78-3.16,14,14,0,0,0-5-.84,10.34,10.34,0,0,1-2.15-.08,7,7,0,0,1,2.15-.32,12.39,12.39,0,0,1,5.21.72,7.34,7.34,0,0,1,3.92,3.5A3.36,3.36,0,0,1,208.07,201.39Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.11,208a4.22,4.22,0,0,1-.51-2.11,7.29,7.29,0,0,0-.48-2.2,2.74,2.74,0,0,0-2-1.52,37.77,37.77,0,0,0-5.09-.73,5.82,5.82,0,0,1-2.11-.5,17.7,17.7,0,0,1,2.15.1,26.05,26.05,0,0,1,5.2.59,4.05,4.05,0,0,1,1.43.66,3,3,0,0,1,.9,1.2,6.64,6.64,0,0,1,.4,2.37C207,207.15,207.17,207.93,207.11,208Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.44 191.06 170.28 234.6 171.9 236.25 202.1 232.84 242.75 194.12 242.71 192.26 212.44 191.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.17,218.42a7.91,7.91,0,0,0-6.09-2,11.13,11.13,0,0,0-6,2.53,8.11,8.11,0,0,0-3,4.28c-.7,3,1.3,6.17,4,7.63l.38-.44q5.19-4.17,10.39-8.33a3,3,0,0,0,1.2-1.54A2.45,2.45,0,0,0,215.17,218.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.71,214.35s4.09.08,5.42.74,5,4.57,5,4.57,0,2.66-1.06,2.77a11,11,0,0,1,.21,1.8c.1,1.49.32,2.34-1.7,3.62,0,0,.21,2.44-.53,3.08a15.29,15.29,0,0,1-1.6,1.17s-2.34,2.87-3.72,2.66-3.38,1.48-3.38,1.48-7.51-3.11-6.71-4l2.59-2.88s-5.15-3.75-5-4.92.53-1.28.53-1.28-.21-2.23,1.6-2.44c0,0,1.38-2.77,2.76-2.87s10.73,3.29,10.73,3.29l-3.5-3s-3.51-.53-3.4-1.7S210.71,214.35,210.71,214.35Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.09,228.35a49.63,49.63,0,0,1-4.74-2.3,50.7,50.7,0,0,1-4.76-2.29,17.41,17.41,0,0,1,5,1.79A16.78,16.78,0,0,1,210.09,228.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,225.1a37.25,37.25,0,0,1-6.1-2,38.06,38.06,0,0,1-5.91-2.5,36.92,36.92,0,0,1,6.1,2A36.94,36.94,0,0,1,215,225.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.58,194a2,2,0,0,1-.55,0h-1.61l-6-.07-21-.4.19-.08-10.56,11L181.09,227l-6.69,6.79-1.83,1.82a4.82,4.82,0,0,1-.67.61,6,6,0,0,1,.59-.68l1.76-1.9,6.55-6.91,21.79-22.66,10.59-10.93.08-.08h.11l21,.6,6,.22L242,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,253.22l4.52,6.32s4,37.68,2.25,39.41-7.86,1.74-7.86,1.74l-1.66-45.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.7,
    y: 253.22,
    width: 78.34,
    height: 13.08,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,259.54h36.27a0,0,0,0,1,0,0v37.23a6.92,6.92,0,0,1-6.92,6.92H133a6.92,6.92,0,0,1-6.92-6.92V259.54A0,0,0,0,1,126.09,259.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37,271.49a15.4,15.4,0,0,1-.15-2.27,26.19,26.19,0,0,0-.8-6.08,4.09,4.09,0,0,0-.94-1.69,10,10,0,0,0-1.71-1.34,11,11,0,0,0-4.54-1.44c-3.41-.25-7.24-.14-11.22-.1s-7.84-.32-11.17.41a7.34,7.34,0,0,0-4.17,2.11,7.2,7.2,0,0,0-1.32,3.87c-.24,2.58-.19,4.71-.24,6.17,0,.68,0,1.24,0,1.69a2.23,2.23,0,0,1-.06.58,3.8,3.8,0,0,1,0-.58l0-1.69c0-1.46-.13-3.58.06-6.21a7.49,7.49,0,0,1,1.36-4.12,7.7,7.7,0,0,1,4.41-2.32,24.21,24.21,0,0,1,5.45-.47c1.88,0,3.83,0,5.82,0,4,0,7.79-.14,11.29.15a11.17,11.17,0,0,1,4.72,1.55,9.71,9.71,0,0,1,1.77,1.43,4.35,4.35,0,0,1,1,1.87,24,24,0,0,1,.65,6.19c0,.68,0,1.24,0,1.69A3.49,3.49,0,0,1,162.37,271.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1,275.36c0,.16-8,.28-17.81.28s-17.82-.12-17.82-.28,8-.27,17.82-.27S162.1,275.21,162.1,275.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,304.09c-.16,0-.28-6.45-.28-14.4s.12-14.41.28-14.41.27,6.45.27,14.41S136.63,304.09,136.48,304.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.83,304c-.15,0-.28-6.39-.28-14.27s.13-14.28.28-14.28.28,6.39.28,14.28S153,304,152.83,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,265.77a27.26,27.26,0,0,1-.58-6.34,26.48,26.48,0,0,1,.41-6.37,58.37,58.37,0,0,1,.15,6.36A59.08,59.08,0,0,1,187.84,265.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.12,253.42a8,8,0,0,1,.48,2.12c.21,1.33.43,3.17.54,5.21a10.5,10.5,0,0,1-.12,2.93,3.74,3.74,0,0,1-1.22,2.12,2.56,2.56,0,0,1-1.53.62c-.4,0-.6-.1-.59-.13a3,3,0,0,0,1.86-.79,3.45,3.45,0,0,0,1-1.92,11.7,11.7,0,0,0,.06-2.8C202.37,256.72,202,253.45,202.12,253.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.4,130.17a81.3,81.3,0,0,1-3.54-13.39,28.09,28.09,0,0,1,1-13.69c.24-.66,2.31-5.07,3-5,.5,0-.76,4.17-.51,4.6a23.83,23.83,0,0,1,2.73,13.85,63,63,0,0,1-2.73,13.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.43,155.69c0-3.26,0-5.84.08-5.84s11.2-1.17,11.89-12.28c.33-5.36.12-16.47-.19-26.51A20.73,20.73,0,0,0,168.52,91l-1.07,0c-11.59.1-18,10-17.57,21.59L150,147l23,16.46Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.51,149.85a26.9,26.9,0,0,1-14.26-5s3.07,8.42,14.2,8Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.48,120.53a1.58,1.58,0,0,1-1.61,1.52,1.51,1.51,0,0,1-1.56-1.51,1.58,1.58,0,0,1,1.61-1.52A1.51,1.51,0,0,1,184.48,120.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,115.55c-.21.2-1.37-.75-3.07-.83s-3,.71-3.18.49.13-.46.7-.83a4.31,4.31,0,0,1,2.55-.65,4.26,4.26,0,0,1,2.44.92C185.55,115.08,185.71,115.46,185.61,115.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.17,120.63a1.61,1.61,0,0,1-1.61,1.53,1.52,1.52,0,0,1-1.57-1.51,1.59,1.59,0,0,1,1.61-1.53A1.52,1.52,0,0,1,169.17,120.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85,115.41c-.21.2-1.37-.75-3.08-.83s-3,.71-3.17.49.13-.46.7-.83a4.31,4.31,0,0,1,2.55-.65,4.16,4.16,0,0,1,2.43.92C168.79,114.94,169,115.32,168.85,115.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,128.84a11.19,11.19,0,0,1,2.8-.37c.43,0,.85-.09.94-.38a2.2,2.2,0,0,0-.23-1.31c-.35-1.07-.73-2.2-1.12-3.38-1.56-4.82-2.66-8.77-2.46-8.83s1.61,3.79,3.16,8.61c.38,1.19.73,2.32,1.07,3.4a2.49,2.49,0,0,1,.14,1.72,1.12,1.12,0,0,1-.74.61,2.94,2.94,0,0,1-.75.06A11.56,11.56,0,0,1,174.32,128.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.23,129.77c.28,0,.19,1.85,1.71,3.24s3.51,1.29,3.51,1.55-.46.34-1.29.32a4.66,4.66,0,0,1-2.94-1.19,4,4,0,0,1-1.31-2.71C168.88,130.2,169.11,129.75,169.23,129.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.1,108.47c-.19.46-1.89.15-3.9.3s-3.67.6-3.91.17c-.11-.2.19-.62.87-1a6.51,6.51,0,0,1,2.93-.87,6.59,6.59,0,0,1,3,.51C168.83,107.87,169.18,108.26,169.1,108.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,109.84c-.32.37-1.48-.09-2.89-.18s-2.63.13-2.88-.29c-.12-.2.09-.58.63-.92a4,4,0,0,1,2.39-.52,3.92,3.92,0,0,1,2.26.9C185.18,109.25,185.33,109.66,185.19,109.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,120.8c-.19-.09-7.52-2.64-7.66,5s7.53,6.18,7.55,6S150.38,120.8,150.38,120.8Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,128.81s-.14.09-.36.18a1.35,1.35,0,0,1-1,0,3.29,3.29,0,0,1-1.46-3,4.27,4.27,0,0,1,.41-1.89,1.49,1.49,0,0,1,1-1,.68.68,0,0,1,.78.37c.09.22,0,.37.08.38s.17-.12.11-.44a.83.83,0,0,0-.29-.48,1,1,0,0,0-.73-.2,1.85,1.85,0,0,0-1.4,1.15,4.39,4.39,0,0,0-.5,2.11c0,1.54.78,3,1.87,3.32a1.4,1.4,0,0,0,1.22-.18C148,129,148,128.82,148,128.81Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,98.41c1.24-.67-2.42-4.69-5.43-6.09-4.56-2.12-11.53-3.46-15.76-2.3-5.09,1.39-9.33,3.88-11.92,8.48a29.91,29.91,0,0,0-3.5,15.25,9.07,9.07,0,0,0,1,4.66c1.05,1.69,3.08,2.77,3,5.09a3.18,3.18,0,0,0,.76,2.33c1.38,1.49,3.1.11,3.9-1.27,1.69-3,1.91-6.53,2.09-9.94a22.23,22.23,0,0,0-.41-7.24c-.36-1.27-.95-2.48-1.24-3.77a4.56,4.56,0,0,1,.57-3.79,4.64,4.64,0,0,1,.63-.62A7.92,7.92,0,0,1,165,97.77c4.27,1.56,11.57,3.89,13.5,2.45,2.77-2.07,3.44-3.42,3.44-3.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,85.63c-.51.05-12.91,2.28-16.38,11.28s-2.7,11.86-2.7,11.86a6,6,0,0,0-1.33,1c-.54.58.08,3.49,1.7,3.24,12.22-4.78,26.43-4.68,42.22-3.49l12.11.38c3.37.54,4.6-.3,3.2-1.22-1.06-.7-10.51-5-10.51-5l-1.83-1.46-4.69-7.16s.66-.93-.53-1.79S173,84.68,163,85.63Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,102.28l-.47,0-1.35-.09c-1.17-.1-2.87-.16-5-.21a92.42,92.42,0,0,0-16.32,1.29,143.49,143.49,0,0,0-16,3.66c-2,.57-3.65,1.06-4.78,1.39l-1.29.38c-.3.09-.46.12-.46.12l.44-.16,1.29-.42c1.12-.35,2.74-.86,4.76-1.45a136.67,136.67,0,0,1,16-3.73,89.13,89.13,0,0,1,16.36-1.22A65.57,65.57,0,0,1,189.43,102.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5,90.52s13.32-1.55,19.12,1.56l-.67-.37,5.48,2.7a3.51,3.51,0,0,0,2.95.48A26.39,26.39,0,0,0,170.06,90C164.61,87.84,155.86,86.65,151.5,90.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.31,90.59a8.52,8.52,0,0,1,1.22-.73,16.61,16.61,0,0,1,3.61-1.36,19.81,19.81,0,0,1,5.71-.56,16.35,16.35,0,0,1,6.8,1.65,28.13,28.13,0,0,1,3.13,1.87c1,.66,1.93,1.25,2.8,1.9a16.84,16.84,0,0,0,2.49,1.74,5.6,5.6,0,0,0,2.53.63c3.25.19,5.28-.39,5.14-.61a.47.47,0,0,1-.27.25,4.36,4.36,0,0,1-1,.29,18.07,18.07,0,0,1-3.86.22,5.84,5.84,0,0,1-2.61-.63,16.83,16.83,0,0,1-2.53-1.74c-.85-.64-1.83-1.23-2.79-1.89a30.37,30.37,0,0,0-3.11-1.85,16.37,16.37,0,0,0-6.72-1.64,19.94,19.94,0,0,0-5.66.51,17.68,17.68,0,0,0-3.62,1.29c-.41.2-.72.37-.93.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.25,100.68a29.61,29.61,0,0,0,6.57-.86c2.53-.43,5-.76,7.55-1.31,1.9-.43,4.15-.78,5.43-2.09a2.74,2.74,0,0,1-1,2.53,13.17,13.17,0,0,1-4.1,1.6,69.73,69.73,0,0,1-15.13,2.23,16.57,16.57,0,0,1,.63-2.1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M147,95.93c-1.54.59-2.48,1-2.58,2.26-.08,1.07.08,2.38,1.12,2.61a2.64,2.64,0,0,0,1,0L163,98.2a2.36,2.36,0,0,0,1.53-.63,1.65,1.65,0,0,0-.46-2.27,4.62,4.62,0,0,0-2.48-.67A54.43,54.43,0,0,0,147,95.93",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.29,97.8a1.42,1.42,0,0,0,.47-.69,2.05,2.05,0,0,0-.58-2.1,5.07,5.07,0,0,0-3.25-.87c-1.32,0-2.77,0-4.29.11a43.07,43.07,0,0,0-7.69,1c-1,.22-1.75.45-2.28.61l-.61.19a1.16,1.16,0,0,1-.22.06.74.74,0,0,1,.21-.09c.18-.08.38-.15.6-.23a22.27,22.27,0,0,1,2.26-.68,39.5,39.5,0,0,1,7.72-1.08c1.53-.08,3-.1,4.3-.1a5.15,5.15,0,0,1,3.35,1,2.12,2.12,0,0,1,.56,2.23,1.43,1.43,0,0,1-.36.54C164.36,97.77,164.3,97.81,164.29,97.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.21 97.37 175.93 96.69 176.67 99.63 187.87 99.9 186.21 97.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.23,105.81c0-.06,4.62-.51,10.32-1s10.33-.86,10.33-.8-4.61.51-10.31,1S170.24,105.87,170.23,105.81Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApprovalPosts);
export default __webpack_public_path__ + "static/media/no-approval-posts.58c90196fe24fd714ae38fa3c6bf79a9.svg";
export { ForwardRef as ReactComponent };